import { render, staticRenderFns } from "./topic-detail-dialog.component.vue?vue&type=template&id=7363d50e&scoped=true"
import script from "./topic-detail-dialog.component.vue?vue&type=script&lang=ts"
export * from "./topic-detail-dialog.component.vue?vue&type=script&lang=ts"
import style0 from "./topic-detail-dialog.component.vue?vue&type=style&index=0&id=7363d50e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363d50e",
  null
  
)

export default component.exports